import React from 'react';
import { Users, ShieldCheck, ReceiptText, Sparkles } from 'lucide-react';

import css from './StatBar.module.css';

const STATS = [
  { Icon: Users, value: '750+', label: 'Service providers' },
  { Icon: ShieldCheck, value: 'Secure Escrow', label: 'Store your payment securely with WLE' },
  { Icon: ReceiptText, value: 'Expense Billing', label: 'Both sides can bill for expenses or overtime' },
  { Icon: Sparkles, value: 'Matching', label: "We'll automatically match you with providers" },
];

const StatBar = () => {
  return (
    <section className={css.statbar}>
      <div className={css.inner}>
        {STATS.map(({ Icon, value, label }) => (
          <div key={value} className={css.stat}>
            <Icon className={css.icon} />
            <div className={css.value}>{value}</div>
            <div className={css.label}>{label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatBar;
